import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styles from './TableUserPayment.module.scss';
import cn from 'classnames';
export const TableUserPayment = (props) => {
    const { name, gameName, role, isLast } = props;
    return (_jsxs("tr", Object.assign({ className: cn(styles.wrapper, isLast && styles.last) }, { children: [_jsxs("td", { children: [name, gameName && ` (${gameName})`] }), _jsx("td", { children: role })] })));
};
